import { configureStore } from '@reduxjs/toolkit';

import appReducer from 'src/store/app';
import authReducer from 'src/store/auth';
import profileReducer from 'src/store/profile';
import appsReducer from 'src/store/apps';
import categoryReducer from 'src/store/category';
import commandReducer from 'src/store/command';
import automodeReducer from 'src/store/automode';
import chaosReducer from 'src/store/chaos';
import giveawayReducer from 'src/store/giveaway';
import viewerReducer from 'src/store/viewer';

export const rootStore = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    profile: profileReducer,
    apps: appsReducer,
    category: categoryReducer,
    command: commandReducer,
    automode: automodeReducer,
    chaos: chaosReducer,
    giveaway: giveawayReducer,
    viewer: viewerReducer
  }
});
